const DocumentTypes = () => import('./DocumentTypes.vue')
const TemplateEditor = () => import('./TemplateEditor.vue')

const DocumentVariables = () => import('./DocumentVariables.vue')
const DocumentVariableDetails = () => import('./DocumentVariableDetails.vue')

export default [
  // Templates de Documentos (autoGenerated = true)
  {
    name: 'document-templates',
    path: 'document-templates',
    component: DocumentTypes,
    props: { mode: 'template' },
    meta: {
      access: ['org.documentTemplate.manage']
    }
  },
  {
    name: 'document-template-editor',
    path: 'document-templates/:documentTypeId/edit',
    component: TemplateEditor,
    meta: {
      access: ['org.documentTemplate.manage']
    }
  },
  // Tipos de Upload (autoGenerated = false)
  {
    name: 'document-upload-types',
    path: 'document-upload-types',
    component: DocumentTypes,
    props: { mode: 'upload' },
    meta: {
      access: ['org.documentTemplate.manage']
    }
  },
  // Variaveis de Documento
  {
    name: 'document-variables',
    path: 'document-variables',
    component: DocumentVariables,
    meta: {
      access: ['org.documentVariable.view']
    },
    children: [
      {
        name: 'document-variable-edit',
        path: ':documentVariableId/edit',
        components: {
          modal: DocumentVariableDetails
        },
        meta: {
          showModal: true,
          access: ['org.documentVariable.manage']
        }
      },
      {
        name: 'document-variable-new',
        path: 'new',
        components: {
          modal: DocumentVariableDetails
        },
        meta: {
          showModal: true,
          access: ['org.documentVariable.manage']
        }
      }
    ]
  }
]
